module.exports = __webpack_public_path__ + "static/media/banner-blog.501c5d5c.jpg";